// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import ExampleComponent1 from "./components/ExampleComponent1";
import DrillDown from "./utils/jquery.drilldown.min"
import Slick from "./utils/slick.min"
import Accordion from "./components/_1_accordion";
import SwitchIcon from "./components/_1_switch-icon";
import DiagonalMovement from "./components/_1_diagonal-movement";
import ModalWindow from "./components/_1_modal-window";
import Tabs from "./components/_1_tabs";
import Ticker from "./components/_1_ticker";
import RevealEffects from "./components/_1_reveal-effects";
import LanguagePicker from "./components/_1_language-picker";
import SwipeContent from "./components/_1_swipe-content";
// import MainHeader from "./components/_2_main-header-v3";
import Carousel from "./components/_2_carousel";
import Dropdown from "./components/_2_dropdown";

import AnimatedMenuButton from "./components/_1_anim-menu-btn";
import OffCanvasContent from "./components/_1_off-canvas-content";
import OffCanvasNavigation from "./components/_2_off-canvas-navigation";


// you can also require modules if they support it…
// const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

//////////////////////////////////////
/// OPTIONS FOR DRILLDOWN MENU
///////////////////////////////////

var options = {
    event: "click", // * View note below
    selector: "a", // * View note below
    speed: 100,
    cssClass: {
        container: "drilldown-container",
        root: "drilldown-root",
        sub: "drilldown-sub",
        back: "drilldown-back",
    },
};


///// RESET THE DRILLDOWN MENU WHEN CLOSING THE OPEN MENU SO ON NEXT REOPEN ITS ON L1 ITEMS
// Initialize the MutationObserver
const observer = new MutationObserver(function(mutationsList) {
    // Check each mutation
    for (const mutation of mutationsList) {
        // If 'aria-hidden' attribute is modified
        if (mutation.attributeName === 'aria-hidden') {
            const target = mutation.target;
            // If the new value of 'aria-hidden' is 'true'
            if (target.getAttribute('aria-hidden') === 'true') {
                // Reset the drilldown menu initialized with class 'drilldown'
                jQuery('.drilldown').drilldown('reset');
            }
        }
    }
});

// Target the div with id 'off-canvas-navigation'
const targetNode = document.getElementById('off-canvas-navigation');

// Options for the observer (which mutations to observe)
const config = { attributes: true };

// Start observing the target node for configured mutations
observer.observe(targetNode, config);



// Initialise our components on jQuery.ready…
jQuery(function ($) {
    $(".drilldown").drilldown(options);



    // ExampleComponent1.init();
    // ExampleModule2.init();
    ReplaceObfuscatedEmailAddresses.init();
    // AnimateOnPageLinks.init();
});